'use strict';

angular.module('internal.services')
    .controller('PreviewServiceInspections', ['$scope', '$rootScope', '$stateParams', 'Services', function ($scope, $rootScope, $stateParams, Services) {
        $scope.serviceId = $stateParams.id;
        $scope.serviceLoading = true;
        $scope.bulkActionItems = [];
        $scope.assigning = false;

        Services.getByID($scope.serviceId, false).then(function (service) {
            $scope.service = service;
            $scope.serviceLoading = false;
        });

        $scope.payInspectionFees = function () {
            //do nothing on preview
        }

        $scope.columns = [
            {
                label: 'Service/Vehicle',
                field: 'name',
                hideAction: 'checklist.payment_handled',
                document: {
                    id: 'checklist.document.id',
                    code: 'checklist.document.code',
                    url: $rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument'
                },
                info: [
                   {
                       label: 'Unit Number',
                       field: 'unit_number'
                   },
                   {
                       label: 'Call Sign',
                       field: 'call_sign'
                   }
                ]
            },
            {
                label: 'Number',
                field: 'number'
            },
            {
                label: 'Date',
                field: 'inspection_date',
                type: 'datetime',
                dateTimeFlag: 'date_time_set'
            },
            {
                label: 'Total Fee',
                field: 'total_fee',
                type: 'money'
            },
            {
                label: 'Deficiencies',
                field: 'checklist.deficiencies_fail',
                type: 'deficiency_total'
            },
            {
                label: 'Status',
                field: 'status.name'
            }
        ];

        $scope.filters = [
            {
                name: 'Status',
                field: 'status_id',
                service: 'IPStatuses'
            }
        ];
    }])
;